import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './index.scss';
import { formatLastSeenRelative } from '../../../utils/presenceUtils';

const OnlineStatus = ({ online = false, lastSeen = null, className }) => {
    const { t, i18n } = useTranslation();
    const locale = i18n.resolvedLanguage || i18n.language;
    const relative = formatLastSeenRelative(lastSeen, { locale });
    const tooltip = useMemo(() => {
        if (online) {
            return t('presence.status.online');
        }
        if (relative) {
            return t('presence.status.lastSeen', { relative });
        }
        return t('presence.status.offline');
    }, [online, relative, t]);

    return (
        <span
            className={`online-status-dot ${online ? 'online-status-dot--online' : 'online-status-dot--offline'}${className ? ` ${className}` : ''}`}
            aria-label={tooltip}
            role="status"
            title={tooltip}
        />
    );
};

OnlineStatus.propTypes = {
    online: PropTypes.bool,
    lastSeen: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
    ]),
    className: PropTypes.string,
};

export default OnlineStatus;
